<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-11 10:34:58
-->

<template>
  <a-config-provider :locale="locale" :theme="theme">
    <router-view></router-view>
  </a-config-provider>
</template>

<script setup>
    import { reactive, ref, toRefs,watch, onMounted} from 'vue'
    import { useStore } from '@/store/index.js';
    import zhCN from 'ant-design-vue/es/locale/zh_CN'
    import enUS from 'ant-design-vue/es/locale/en_US'
    import deDE from 'ant-design-vue/es/locale/de_DE'
    import frFR from 'ant-design-vue/es/locale/fr_FR'
    import dayjs from 'dayjs'
    import 'dayjs/locale/zh-cn'
    import 'dayjs/locale/en-gb'
    // import 'dayjs/locale/de-de'
    // import 'dayjs/locale/fr-fr'

    dayjs.locale('zh-cn')
    dayjs.locale('en-gb')
    // dayjs.locale('de-de')
    // dayjs.locale('fr-fr')

    const store = useStore()
    const locale = ref('')
    const theme = reactive({
      token: {
        colorPrimary: '#1226aa',
      },
    })

    
    if(localStorage.getItem('app_console_lang')){
      let cache_lang = localStorage.getItem('app_console_lang')
      locale.value = cache_lang == 'zh'? zhCN : cache_lang == 'en'? enUS : cache_lang == 'de'? deDE : cache_lang == 'fr'? frFR : enUS
    }else{
      locale.value = enUS
    }

    onMounted(()=>{})
    
</script>


<style lang="scss">
body,#app {
  font-family: HelveticaNeueLTPro, Avenir, Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

button:focus, 
button:focus-visible{
  outline: none;
}
</style>
